import { theme } from "../../../utils/styles";

const floatingMenuStyles = {
  container: {
    position: "fixed",
    right: "1em",
    zIndex: 1000,
  },
  menuToggle: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    backgroundColor: "#9053F6",
    boxShadow: "4px 4px 2px 1px rgba(0,0,0,0.2)",
    position: "absolute",
    bottom: 0,
    right: "0px",
    zIndex: 5,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "& span": {
      transition: "0.4s",
    },
    [theme.breakpoints.down("md")]: {
      width: "50px",
      height: "50px",
      "& svg": {
        fontSize: "22px !important",
      },
    },
    [theme.breakpoints.down("sm")]: {
      width: "40px",
      height: "40px",
      "& svg": {
        fontSize: "19px !important",
      },
    },
  },
  menuToggleActive: {
    backgroundColor: "#7033D3",
    boxShadow: "0 0 15px rgba(144, 83, 246, 0.6)",
  },
  menuToggleInactive: {
    pointerEvents: "none",
    filter: "brightness(0.7)",
    boxShadow: "none",
  },
  menuRound: {
    position: "absolute",
    bottom: "-2px",
    right: "-1px",
    zIndex: 3,
  },
  btnApp: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: "1px solid rgba(255, 255, 255, 0.21)",
    background: "rgba(255, 255, 255, 0.14)",
    boxShadow: "inset 0 1000px rgba(255, 255, 255, .08)",
    color: "#fff",
    position: "absolute",
    bottom: "0",
    right: "0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "0.4s",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#9053F6",
    },
    [theme.breakpoints.down("md")]: {
      width: "50px",
      height: "50px",
      "& svg": {
        fontSize: "22px !important",
      },
      "& img": {
        width: "22px !important",
        height: "22px !important",
      },
    },
    [theme.breakpoints.down("md")]: {
      width: "50px",
      height: "50px",
      "& svg": {
        fontSize: "22px !important",
      },
      "& img": {
        width: "22px !important",
        height: "22px !important",
      },
    },
    [theme.breakpoints.down("sm")]: {
      width: "40px",
      height: "40px",
      "& svg": {
        fontSize: "19px !important",
      },
      "& img": {
        width: "19px !important",
        height: "19px !important",
      },
    },
  },
  openFirstBtn: {
    right: "-0.5em",
    bottom: "5.25em",
    transitionDelay: "0.2s",
  },
  openSecondBtn: {
    right: "3.5em",
    bottom: "4.5em",
    transitionDelay: "0.1s",
  },
  openThirdBtn: {
    right: "5.25em",
    bottom: "0.5em",
  },
  openFourthBtn: {
    right: "3.25em",
    bottom: "-3.25em",
    transitionDelay: "0.15s",
  },
  openFifthBtn: {
    right: "-0.5em",
    bottom: "-5em",
    transitionDelay: "0.2s",
  },
  menuLine: {
    position: "absolute",
    bottom: "-1.5em",
    right: 0,
    zIndex: 2,
  },
  verticalBtn: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: "1px solid rgba(255, 255, 255, 0.21)",
    background: "rgba(255, 255, 255, 0.14)",
    boxShadow: "inset 0 1000px rgba(255, 255, 255, .08)",
    color: "#fff",
    position: "absolute",
    bottom: 0,
    right: "-0.5em",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "0.3s",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#9053F6",
    },
    [theme.breakpoints.down("md")]: {
      width: "50px",
      height: "50px",
      "& svg": {
        fontSize: "22px !important",
      },
      "& img": {
        width: "22px !important",
        height: "22px !important",
      },
    },
    [theme.breakpoints.down("sm")]: {
      width: "40px",
      height: "40px",
      "& svg": {
        fontSize: "19px !important",
      },
      "& img": {
        width: "19px !important",
        height: "19px !important",
      },
    },
  },
  backdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    opacity: 0,
    visibility: "hidden",
    transition: "opacity 0.3s, visibility 0.3s",
  },
  backdropOpen: {
    opacity: 1,
    visibility: "visible",
  },
  tooltip: {
    bgcolor: "#321751",
    color: "white",
    fontSize: "1.25rem",
    padding: "10px 20px",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    borderRadius: "8px",
    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
    backdropFilter: "blur(5px)",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      transform: "scale(1.02)",
    },
  },
  containerInactive: {
    pointerEvents: "none",
    filter: "brightness(0.7)",
    zIndex: 999,
  },
};

export default floatingMenuStyles;
